import router from './router'
import store from './store'

const whiteList = ['/Login','/Signup','/ForgetPassword','/ResetPassword']

router.beforeEach(async(to, from, next) => {

  const hasToken = localStorage.getItem('token')

  if (hasToken) {
    if (to.path === '/Login') {
      next()
    } else {
      const hasGetUserInfo = store.getters.name
      if (hasGetUserInfo) {
        next()
      } else {
        try {
          next()
        } catch (error) {
          next(`/Login?redirect=${to.path}`)
        }
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next()
    }
  }
})
